<template>
  <div class="app-main-inner app-main-page-tab">
    <div class="app-main-inner-row">
      <el-checkbox :label="$t('Clearing.Booking')" />
      <el-checkbox :label="$t('Clearing.CustomsClearance')" />
      <el-checkbox label="MB/L" />
      <el-checkbox label="HB/L" />
      <el-checkbox :label="$t('Clearing.FormalHouseWaybill')" />
      <el-checkbox label="VGM" />
      <el-checkbox label="AMS/ENS" />
      <el-checkbox label="HDS" />
      <el-checkbox :label="$t('Clearing.CommodityInspection')" />
      <el-checkbox :label="$t('Clearing.Fumigation')" />
      <el-checkbox :label="$t('Clearing.ForeignTrade')" />
    </div>
    <div class="app-main-inner-row">
      <el-form ref="basicForm" style="min-width:100%;" label-position="left" label-width="90px">
        <el-row :gutter="10">
          <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
            <fieldset style="min-height:750px;">
              <legend>{{ $t('Clearing.EntrustedInformation') }}</legend>
              <!--<div class="el-form-item-group" style="min-height:750px;">-->
              <el-form-item :label="$t('Clearing.BusinessNumber')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.Client')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.CustomerAttribute')">
                <span>Lv1</span> <span style="color:#ffc65f">{{ $t('Clearing.VipCooperativeCustomer') }}</span> <span style="color:red">（未签约）</span>
              </el-form-item>
              <el-form-item label="联系人">
                <div style="display: flex">
                  <el-select style="width:200px;">
                    <el-option :label="$t('Clearing.Dropdown')" :value="0" />
                  </el-select>
                  <div style="display:inline-block;border-bottom:1px solid black;font-size:12px;">{{ $t('Clearing.DetailedInformation') }}</div>
                </div>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_FLCLType')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_CargoType')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.OrderChannel')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_SailingDate')">
                <div style="display: flex">
                  <el-date-picker
                    type="date"
                    style="width:150px;"
                    clearable
                  />
                  <el-select style="width: 100px;">
                    <el-option :label="$t('Clearing.Dropdown')" :value="0" />
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item :label="$t('Clearing.ArrivalDate')">
                <el-date-picker
                  type="date"
                  style="width:251px;"
                  clearable
                />
              </el-form-item>
              <el-form-item :label="$t('Clearing.OperationDate')">
                <el-date-picker
                  type="date"
                  style="width:251px;"
                  clearable
                />
              </el-form-item>
              <el-form-item :label="$t('Clearing.ShippingOfBillOfLading')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.OriginPortPOL')">
                <div style="display: flex">
                  <el-input style="width:170px;" />
                  <el-checkbox style="width:80px;">{{ $t('Clearing.Transshipment') }}</el-checkbox>
                </div>
              </el-form-item>
              <el-form-item :label="$t('SeaExport.PortOfDischarge')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.DeliveryPlace')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.Route')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.FinalDestination')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.ShippingCompany')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.BookingAgent')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.ShipAgent')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.CargoType')">
                <div style="display: flex">
                  <el-select style="width: 125px;">
                    <el-option :label="$t('Clearing.Dropdown')" :value="0" />
                  </el-select>
                  <el-select style="width: 125px;">
                    <el-option :label="$t('Clearing.Dropdown')" :value="0" />
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item :label="$t('Clearing.DestinationPortAgent')">
                <el-input />
              </el-form-item>
            <!--</div>-->
            </fieldset>
          </el-col>

          <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
            <fieldset style="min-height:750px;">
              <legend>{{ $t('Clearing.AdditionalInformation') }}</legend>
              <el-form-item :label="$t('SeaExport.LocalService')">
                <div style="display: flex;flex-direction:column;padding-left:10px;height: 100px;border-radius:5px;border: 1px solid #dcdcdc;background: white">
                  <el-checkbox>{{ $t('Clearing.ContainerPackingWarehouse') }}</el-checkbox>
                  <el-checkbox>{{ $t('Clearing.DoorToDoorLoadingCollection') }}</el-checkbox>
                  <el-checkbox>{{ $t('Clearing.SelfPickupSelfDelivery') }}</el-checkbox>
                </div>
              </el-form-item>
              <el-form-item :label="$t('Clearing.WarehouseEntryNumber')">
                <el-input />
                <div style="display: flex;justify-content: space-between">
                  <el-button>{{ $t('Clearing.AutomaticAllocation') }}</el-button>
                  <el-button>{{ $t('Clearing.WarehousingInformation') }}</el-button>
                </div>
              </el-form-item>
              <el-form-item :label="$t('SeaExport.MblNo3')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.BusinessReferenceNumber')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.ProjectNumber')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.CustomsBroker')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.TradeMethod')">
                <el-select>
                  <option :label="$t('Clearing.Dropdown')" />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('Clearing.TransportationCompany')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.Warehouse')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.MasterWaybillTransportTerms')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.HouseWaybillTransportTerms')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.MasterWaybillFreightTerms')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.MasterWaybillPaymentLocation')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.HouseWaybillFreightTerms')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.HouseWaybillFreightTerms')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.HouseWaybillPaymentLocation')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.PricingNature')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.TradeTerms')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.CargoDimensions')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.SpecialPriceExplanation')">
                <el-input />
              </el-form-item>
            </fieldset>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
            <fieldset style="min-height:750px;">
              <legend>{{ $t('Clearing.CargoBoxInformation') }}</legend>
              <el-form-item :label="$t('Message.NumberOfPiecescommissionactual')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.GrossWeightEntrustedActual')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.VolumeEntrustedActual')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.Packing')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.NumberOfSmallPieces')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.SmallPiecePacking')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.ChargeableWeightRT')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.EnglishProductName')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.ShippingMarks')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.HSCode')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.ChineseProductName')">
                <el-input />
              </el-form-item>
              <el-form-item label="">
                <el-input />
              </el-form-item>
            </fieldset>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
            <fieldset style="min-height:750px;">
              <legend>{{ $t('Clearing.OperationInformation') }}</legend>
              <el-form-item :label="$t('CargoMsg.Cargo_SalesCompany')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.Sales')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.CargoSales')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.SalesDepartment')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.OperatingCompany')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.OperatingDepartment')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.Operation')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.CustomerService')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.OverseasCustomerService')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.Documentation')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.RouteResponsiblePerson')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.OperationRequirements')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.OperationTips')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.AdditionalFeeTerms')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.WarehouseEntryInformation')">
                <el-input />
              </el-form-item>
              <el-form-item :label="$t('Clearing.Remarks')">
                <el-input />
              </el-form-item>
              <el-form-item label="">
                <el-input />
              </el-form-item>
            </fieldset>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
            <fieldset style="min-height:500px;">
              <legend>{{ $t('Clearing.CustomInformation') }}</legend>
              <el-form-item :label="$t('Clearing.CustomField1')">
                <el-input type="textarea" rows="5" />
              </el-form-item>
              <el-form-item :label="$t('Clearing.CustomField2')">
                <el-input type="textarea" rows="5" />
              </el-form-item>
              <el-form-item :label="$t('Clearing.CustomField3')">
                <el-input type="textarea" rows="5" />
              </el-form-item>
              <el-form-item :label="$t('Clearing.CustomField4')">
                <el-input type="textarea" rows="5" />
              </el-form-item>
            </fieldset>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <fieldset>
              <legend>{{ $t('Clearing.CustomerShippingInformation') }}</legend>
              <div style="display: flex;justify-content: space-between">
                <div class="el-form-item-group" style="flex-grow: 1">
                  <el-form-item :label="$t('Clearing.Shipper')">
                    <el-input>
                      <el-button slot="append" type="primary" style="background: #1890ff;color:white">{{ $t('Clearing.CodeRetrieval') }}</el-button>
                    </el-input>
                  </el-form-item>
                  <el-input />
                  <el-input />
                  <el-input />
                  <el-input />
                  <el-input />
                  <el-input />
                  <el-input />
                </div>
                <div class="el-form-item-group" style="flex-grow: 1">
                  <el-form-item :label="$t('Clearing.Shipper')">
                    <el-input>
                      <el-button slot="append" type="primary">{{ $t('Clearing.CodeRetrieval') }}</el-button>
                    </el-input>
                  </el-form-item>
                  <el-input />
                  <el-input />
                  <el-input />
                  <el-input />
                  <el-input />
                  <el-input />
                  <el-input />
                </div>
                <div class="el-form-item-group" style="flex-grow: 1">
                  <el-form-item :label="$t('Clearing.Shipper')">
                    <el-input>
                      <el-button slot="append" type="primary">{{ $t('Clearing.CodeRetrieval') }}</el-button>
                    </el-input>
                  </el-form-item>
                  <el-input />
                  <el-input />
                  <el-input />
                  <el-input />
                  <el-input />
                  <el-input />
                  <el-input />
                </div>
                <div class="el-form-item-group" style="width:570px">
                  <el-form-item :label="$t('Clearing.SecondNotifyParty')" />
                  <el-input type="textarea" rows="5" />
                </div>
              </div>
            </fieldset>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
export default {
  name: 'BasicTab',
  components: {},
  data() {
    return {
      loading: false,
      oneBasic: {
        types: {
          booking: false
        }
      }

    }
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
